import Icon from "@/components/Icon";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/i18n";

const POSTERS = [
    {
        src: "/images/brands/poster-range.jpg",
        alt: "Farakka Broadband product range — Smarten inverters and batteries, INTU lithium batteries, Exide and Amaron",
    },
    {
        src: "/images/brands/poster-intu.jpg",
        alt: "INTU lithium home UPS battery range — INTU+, INTU X and INTU PRO",
    },
];

export default function Brands() {
    const { t } = useLang();
    return (
        <section id="brands" data-testid="brands-section" className="relative py-24 md:py-32 bg-navy border-t border-ink/5 overflow-hidden">
            <div className="absolute -top-32 right-0 w-[28rem] h-[28rem] bg-solar/8 blur-[130px] rounded-full pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-6 md:px-12">
                <Reveal>
                    <Eyebrow color="text-solar">{t.brands.eyebrow}</Eyebrow>
                    <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-ink mt-4">
                        {t.brands.headingA}<span className="text-solar">{t.brands.headingB}</span>
                    </h2>
                    <p className="mt-4 max-w-xl text-ice/60 text-base md:text-lg">
                        {t.brands.sub}
                    </p>
                </Reveal>

                <Reveal delay={0.1}>
                    <div className="mt-10 flex flex-wrap gap-3">
                        {t.brands.chips.map((b, i) => (
                            <span
                                key={b.name}
                                data-testid={`brand-chip-${i}`}
                                className="flex items-center gap-2.5 glass rounded-full px-5 py-2.5 text-sm text-ink/85"
                            >
                                <Icon name="zap" size={15} className="text-solar" />
                                <span className="font-semibold">{b.name}</span>
                                <span className="text-ice/45">· {b.note}</span>
                            </span>
                        ))}
                    </div>
                </Reveal>

                <Reveal delay={0.12}>
                    <a
                        data-testid="brands-catalogue-download"
                        href="/docs/Smarten-Product-Catalogue-2021-22.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-6 inline-flex items-center gap-2 rounded-full border border-solar/50 px-6 py-3 text-sm font-semibold text-solar hover:bg-solar hover:text-ink transition-colors duration-300"
                    >
                        <Icon name="download" size={15} />
                        {t.products.downloadCatalogue}
                    </a>
                </Reveal>

                <div className="mt-10 grid gap-6 md:grid-cols-2">
                    {POSTERS.map((p, i) => (
                        <Reveal key={p.src} delay={0.15 + i * 0.12}>
                            <div
                                data-testid={`brand-poster-${i}`}
                                className="group rounded-2xl border border-ink/8 bg-surface overflow-hidden hover:border-solar/30 transition-colors duration-300"
                            >
                                <img
                                    src={p.src}
                                    alt={p.alt}
                                    loading="lazy"
                                    className="w-full h-72 md:h-96 object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
                                />
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
